import {createContext} from 'react';

import {OptionStatusIndicator} from '../../../types/OptionTypeBase';

/**
 * Provides per-option status indicators (e.g. the user-absence red dot) to the
 * suggestion menu items. Keyed by the option id, because the mentions library
 * only carries primitive item data and cannot transport the indicator object
 * (which holds a ReactNode tooltip) through its own data channel.
 */
export const MenuItemStatusIndicatorContext = createContext<Map<string, OptionStatusIndicator>>(
  new Map()
);
